import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { LoginConciergeResponse } from './concierge.reducers'

export const ConciergeActions = createActionGroup({
	source: 'Concierge',
	events: {
		'Load Concierge': emptyProps(),
		'Login Concierge User': props<{ username: string; password: string; partnerId: string }>(),
		'Login Concierge User Success': props<{ conciergeUser: LoginConciergeResponse }>(),
		'Login Concierge User Failure': props<{ error: string }>(),
		'Logout Concierge User': emptyProps(),
		'Set Concierge User': props<{ conciergeUser: LoginConciergeResponse }>(),
		'Reset Concierge User': emptyProps(),
	},
})
